import React from 'react'
import {NewsWrap, NewsItem, NewsItemList, NewsException} from 'src/styles/views/Support/News'
import {CustomBtn} from 'src/styles/common/CommonForm/buttonform'
import {TYPE_NEWS} from 'src/service/constant/cmdtype'
import {COLOR} from 'src/service/constant/color'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import Loading from 'src/component/common/Loading'
import {useNewsListQueryData} from 'src/hooks/reactquery'
import {useMoreButton} from 'src/hooks/useMoreButton'
import news_exception from 'src/assets/common/news_exception.png'

const News = () => {
    const {width} = useWindowDimensions()
    const [more, onChangeMore] = useMoreButton(0)
    const {isLoading, data: NewsListData} = useNewsListQueryData(TYPE_NEWS, more)
    return (
        <>
            {NewsListData?.Body.length !== 0
                ? <NewsWrap>
                    {isLoading && <Loading/>}
                    <NewsItemList>
                        {NewsListData?.Body.map((option: any, index: number) => (
                            <NewsItem key={index}>
                                <img src={option.ImgPath} alt='test33'/>
                                <a href={option.LinkPath} target='_blank' rel='noreferrer'>{option.NewsTitle}</a>
                            </NewsItem>
                        ))}
                    </NewsItemList>
                    {NewsListData?.Body?.length >= (more + 1) * 6 &&
                        <CustomBtn
                            color={COLOR.point1}
                            bgColor={COLOR.white}
                            borderColor={COLOR.point1}
                            borderRadius={"40px"}
                            marginTop={width > 1200 ? "68px" : "38px"}
                            width={width > 1200 ? "356px" : "328px"}
                            height={width > 1200 ? "56px" : "44px"}
                            fontSize={width > 1200 ? "18px" : "14px"}
                            fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                            onClick={onChangeMore}
                        >
                            <span>더보기</span>
                        </CustomBtn>
                    }
                </NewsWrap>
                : <NewsException>
                    <img src={news_exception} alt=''/>
                    <p>서비스 관련 새소식을 준비 중입니다.</p>
                </NewsException>}
        </>
    )
}

export default News
